import { FC, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { selectedInvestmentStateFinance, showModalStateFinance } from '../state/FinanceUIStateJ';
import { RoundTable } from './RoundTable';
import { RoundModals } from './modals/RoundModals';

export const FinanceRounds: FC = () => {
  const setModalState = useSetAtom(showModalStateFinance);
  const setSelectedInvestment = useSetAtom(selectedInvestmentStateFinance);

  useEffect(() => {
    return () => {
      setModalState(null);
      setSelectedInvestment(null);
    };
  });

  return (
    <>
      <RoundTable />
      <RoundModals />
    </>
  );
};
